import { render, staticRenderFns } from "./AdminUserMenu.vue?vue&type=template&id=5bcbfe3c&scoped=true"
import script from "./AdminUserMenu.vue?vue&type=script&lang=js"
export * from "./AdminUserMenu.vue?vue&type=script&lang=js"
import style0 from "./AdminUserMenu.vue?vue&type=style&index=0&id=5bcbfe3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcbfe3c",
  null
  
)

export default component.exports